import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from '@/components/feature/StructuredData';
import HeroSection from './components/HeroSection';
import TrendingGrid from './components/TrendingGrid';
import ExclusiveSection from './components/ExclusiveSection';
import LatestArticles from './components/LatestArticles';
import AppDownloadCTA from './components/AppDownloadCTA';
import ReviewSection from './components/ReviewSection';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="91在线视频 - 官网入口与app下载 | 网红黑料吃瓜爆料与热门事件追踪"
        description="91在线视频官网入口与app下载页面，提供最新网址与网红黑料吃瓜爆料内容，实时追踪热门事件。"
        url="https://www.91zaixianshipin.com/"
        datePublished="2025-01-01"
        dateModified="2026-07-07"
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrendingGrid />
        <ExclusiveSection />
        <LatestArticles />
        <AppDownloadCTA />
        <ReviewSection />
      </main>
      <Footer />
    </>
  );
}